import Tabs from './Tabs'

const Home = () => {

  return (<Tabs />)

}

export default Home
